<template>
    <app-layout>
        <template #header>
            <div class="relative flex justify-between items-center">
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    <i class="fas fa-coins" />
                    Criptoativos
                </h2>
                <balance :short="true" />
            </div>
        </template>
        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <MenuCripto />
                <crypto-balance class="mt-6"/>
                <div class="flex justify-between mt-8">
                    <h2 class="text-black text-opacity-70 text-xl font-bold">
                        Extrato
                    </h2>
                </div>
                <div class="bg-white shadow-md sm:rounded-lg p-6 mt-6">
                    <flash :timeout="0"/>

                    <div class="flex justify-between items-center -mb-10">
                        <h3 class="text-black text-opacity-70 text-xl font-bold">
                            Lista de transações
                        </h3>
                        <date-filter
                            v-if="false"
                            :buttons="buttonsFilter"
                            :filter="$page.props.queryString.interval"
                        />
                    </div>

                    <inertia-table
                        :data="extracts"
                        :params="params"
                        :filters="filters"
                        :enable-search="false"
                        :enable-pages="true"
                        :enable-export="false"
                        :enable-display="true"
                        :columns="columns"
                        :hasLine="false"
                        :has-icon="false"
                        :icon="false"
                        tableClasses="border-t-2 mt-8"
                        id="tradelist"
                        routeName="extract-crypto.index"
                        parent="trade"
                        @item-selected="() => null"
                    >
                        <template slot="transaction" slot-scope="{ item }">
                            <div>
                                <span class="font-bold text-sm">
                                    {{ item.movement_type === 'D' ? 'Saque': '' }}
                                    {{ item.movement_type === 'C' ? 'Depósito': '' }}
                                    {{ item.movement_type === 'T' ? 'Compra': '' }}
                                </span>
                                <div v-if="item.movement_type !== 'C'" class="flex items-center">
                                    <Icons
                                        v-if="returnParamsIcon(item, 'icon')"
                                        :icon="returnParamsIcon(item, 'icon')"
                                        :color="returnParamsIcon(item, 'color')"
                                        :size="'2'"
                                        otherClass="mr-2"
                                    />
                                    <div>
                                        {{ item.movement_type === 'D' && item.withdraw ? item.withdraw.coin : '' }}
                                        {{ item.movement_type === 'T' ? item.operation.coin : '' }}
                                    </div>
                                </div>
                                <div v-if="item.movement_type === 'C'" class="flex items-center gap-x-2">
                                    <div
                                        class="flex items-center w-6 h-6 rounded-full bg-gray-700 font-bold text-white justify-center"
                                    >
                                        R$
                                    </div>
                                    BRL
                                </div>
                            </div>
                        </template>
                        <template slot="created" slot-scope="{ item }">
                            {{ item.created | smallDateTime }}
                        </template>
                        <template slot="quantity" slot-scope="{ item }">
                            <div v-if="item.withdraw">
                                {{ numberFormat(item.withdraw?.crypto_amount ?? 0, item.withdraw?.coin ) }} {{ item.withdraw?.coin }}
                            </div>
                            <div v-else-if="item.operation">
                                {{ numberFormat(item.operation?.amount ?? 0, item.operation?.coin) }} {{ item.operation?.coin }}
                            </div>
                            <div v-else-if="item.transaction">
                                {{ numberFormat(item.transaction?.amount ?? 0, 'BRL') }} BRL
                            </div>
                            <div v-else>--</div>
                        </template>
                        <template slot="price" slot-scope="{ item }">
                            <div v-if="item.operation">
                                R$ {{ formatValue(item.operation.unit_value) }}
                            </div>
                            <div v-else>--</div>
                        </template>
                        <template slot="value" slot-scope="{ item }">
                            <div class="font-semibold">
                                R$ {{ item.amount | currency }}
                            </div>
                        </template>
                        <template slot="balance" slot-scope="{ item }">
                            R$ {{ item.balance | currency }}
                        </template>
                        <template slot="action" slot-scope="{ item }">
                            <div v-if="item.movement_type !== 'C'" class="text-green-500">
                                <div
                                    class="cursor-pointer rounded-full bg-white shadow-lg text-gray-900 h-10 w-10 flex justify-center items-center text-center"
                                    @click="selectedExtract = item, showReceipt = true"
                                >
                                    <i class="fas fa-receipt"/>
                                </div>
                            </div>
                        </template>
                    </inertia-table>
                </div>
            </div>
        </div>

        <jet-dialog-modal :show="showReceipt" maxWidth="md" position="fixed" id="transfer-receipt">
            <template #title>
                Comprovante de {{ selectedExtract?.withdraw ?  'saque' : selectedExtract?.operation ? 'compra' : 'depósito' }}
            </template>
            <template #content>
                <div class="border-t border-gray-300 text-center">
                    <div class="flex justify-center mt-3 border-b pb-2">
                        <img :src="$page.props.white_label.data.logo_white">
                    </div>

                    <div class="pt-3 pb-5 text-lg text-black font-semibold">
                        Detalhes do {{ selectedExtract?.withdraw ?  'saque' : selectedExtract?.operation ? 'compra' : 'depósito' }}
                    </div>
                </div>
                <div class="px-4">
                    <div class="flex justify-between mb-2">
                        <div class="text-gray-500">
                            Moeda
                        </div>
                        <div>
                            {{ selectedExtract?.withdraw?.coin }}
                            {{ selectedExtract?.operation?.coin }}
                        </div>
                    </div>
                    <div v-if="selectedExtract?.withdraw" class="flex justify-between mb-2">
                        <div class="text-gray-500">
                            Rede
                        </div>
                        <div class="uppercase">
                            {{ selectedExtract?.withdraw?.wallet_network }}
                        </div>
                    </div>
                    <div v-if="selectedExtract?.operation" class="flex justify-between mb-2">
                        <div class="text-gray-500">
                            Preço
                        </div>
                        <div class="uppercase">
                            R$ {{ formatValue(selectedExtract.operation.unit_value) }}
                        </div>
                    </div>
                    <div v-if="selectedExtract?.operation" class="flex justify-between mb-2">
                        <div class="text-gray-500">
                            Valor
                        </div>
                        <div class="uppercase">
                            R$ {{ selectedExtract.amount | currency }}
                        </div>
                    </div>
                </div>
                <hr class="w-full mt-4">
                <div class="pt-3 pb-5 text-center">
                    <div class="text-lg text-black font-semibold">
                        Valor do {{ selectedExtract?.withdraw ?  'saque' : selectedExtract?.operation ? 'compra' : 'depósito' }}
                    </div>
                    <div v-if="selectedExtract?.withdraw" class="text-lg font-bold uppercase">
                        {{
                        `${numberFormat(selectedExtract.withdraw.crypto_amount, selectedExtract.withdraw.coin)}
                            ${selectedExtract?.withdraw?.coin}`
                        }}
                    </div>
                    <div v-else-if="selectedExtract?.operation" class="text-lg font-bold uppercase">
                        {{
                        `${numberFormat(selectedExtract.operation.amount, selectedExtract.operation.coin)}
                            ${selectedExtract?.operation?.coin}`
                        }}
                    </div>
                    <div v-else>--</div>
                </div>
                <div class="flex justify-between mb-2">
                    <div class="text-gray-500">
                        Data
                    </div>
                    <div>
                        {{ selectedExtract?.created | smallDateTime }}
                    </div>
                </div>
                <div class="pt-5 remove-to-print">
                    <div class="flex items-center justify-end">
                        <RoundedIcon
                            class="w-9 h-9 bg-green-500 text-white mr-4"
                            v-tippy
                            content="Baixar em PNG"
                            :icon="'far fa-file-image'"
                            @click.native="print('png')"
                        />
                        <RoundedIcon
                            class="w-9 h-9 bg-red-600 text-white"
                            v-tippy
                            content="Baixar em PDF"
                            :icon="'fas fa-file-pdf'"
                            @click.native="print('pdf')"
                        />
                    </div>
                </div>
            </template>

            <template #footer>
                <secondary-button class="remove-to-print" @click.native="showReceipt = false">
                    FECHAR
                </secondary-button>
            </template>
        </jet-dialog-modal>
    </app-layout>
</template>

<script>
import AppLayout from "../../../Layouts/AppLayout.vue";
import RoundedIcon from '../../Send/components/RoundedIcon.vue';
import Flash from "../../../Helpers/Flash.vue";
import InertiaTable from "../../../Helpers/Tables/InertiaTable.vue";
import Balance from "../../../Helpers/Balance.vue";
import numberFormat from "../utils/numberFormat";
import icons from "../utils/icons";
import Icons from "../components/Icons.vue";
import JetSecondaryButton from '../../../Jetstream/SecondaryButton.vue'
import CryptoBalance from '../Balance.vue';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import moment from 'moment'
import MenuCripto from "../components/MenuCripto.vue";
import DateFilter from "../../../Helpers/Tables/DateFilter.vue";
import JetDialogModal from '../../../Jetstream/DialogModal.vue'
import SecondaryButton from "../../../Jetstream/SecondaryButton.vue";

export default {
    props: ['extracts'],
    data() {
        return {
            icons,
            moment,
            numberFormat,
            cryptos: [],
            selectedExtract: null,
            showReceipt: false,
            buttonsFilter: [
                { name: "Hoje", key: "today" },
                { name: "Ontem", key: "yesterday" },
                { name: "Esta semana", key: "week" },
                { name: "Este mês", key: "month" }
            ],
            columns: [
                {
                    text: "Transação",
                    className: "text-left",
                    key: "transaction",
                    sortable: false
                },
                {
                    text: "Data da execução",
                    className: "text-left",
                    key: "created",
                    sortable: true
                },
                {
                    text: "Quantidade",
                    className: "text-left",
                    key: "quantity",
                    sortable: false
                },
                {
                    text: "Preço",
                    className: "text-left",
                    key: "price",
                    sortable: false
                },
                {
                    text: "Valor",
                    className: "text-left",
                    key: "value",
                    sortable: false
                },
                {
                    text: "Saldo",
                    className: "text-left",
                    key: "balance",
                    sortable: false
                },
                {
                    text: "",
                    className: "text-left",
                    key: "action",
                    sortable: false
                }
            ],
            filters: [
                {
                    text: 'Moeda',
                    key: 'coin',
                    type: 'dropdown',
                    options: [],
                    colSpan: 2
                },
                {
                    text: 'Período',
                    key: 'date',
                    type: 'date_interval2',
                    colSpan: 2
                },
            ],
            params: {
                sort: "created:desc",
                page: 1,
                size: 10,
                ...this.$page.props.queryString
            }
        };
    },
    methods: {
        formatValue(value, min = 4, max = 4){
            return Number(value).toLocaleString('pt-BR', {minimumFractionDigits: min, maximumFractionDigits: max })
        },
        async getCurrencies(){
            const { data } = await axios.get('/crypto/currencies')
            this.cryptos = data.list
            this.filters[0].options = this.cryptos
                .filter(currency => currency.status === 'active')
                .map(currency => ({ ...currency, name: currency.coin, id: currency.id.toUpperCase() }))
        },
        returnParamsIcon(extract, param = "icon") {
            if(extract.movement_type === 'D' && extract.withdraw) {
                return this.icons[extract.withdraw.coin][param];
            }
            if(extract.movement_type === 'T') {
                return this.icons[extract.operation.coin][param];
            }
            return '';
        },
        print(type) {
            const toggleHiddenButtons = () => document
                .querySelectorAll('.remove-to-print')
                .forEach((el) => el.classList.toggle('hidden'))

            toggleHiddenButtons()
            html2canvas(document.querySelector('#transfer-receipt'), {dpi: 144, scale: 1}).then(canvas => {
                let imgData = canvas.toDataURL('image/png');
                if (type === 'png') {
                    const a = document.createElement('a');
                    a.href = imgData;
                    a.download = 'comprovante.png';
                    a.click();
                    return
                }
                let doc = new jsPDF();
                doc.addImage(imgData, 'PNG', 46, 10);
                doc.save(`comprovante.${type}`);
            });
            toggleHiddenButtons()
        },
    },
    created(){
        this.getCurrencies()
    },
    components: {
        Balance,
        CryptoBalance,
        AppLayout,
        Flash,
        InertiaTable,
        Icons,
        JetSecondaryButton,
        RoundedIcon,
        MenuCripto,
        DateFilter,
        Icons,
        JetDialogModal,
        SecondaryButton
    },
};
</script>
